<template>
  <b-container fluid>
    <b-row align-h="end">
      <b-col
        cols="12"
        sm="12"
        md="8"
        lg="6"
        xl="4"
      >
        <s-search-input
          class="mb-3"
          v-model="tempSearch"
          v-s-trigger="searchChange"
          :placeholder="$t('reports.oscillography.view-report.search')"
        />
      </b-col>
    </b-row>

    <b-row
      v-for="maneuver in filteredManeuvers"
      :key="getManeuverKey(maneuver)"
    >
      <b-col cols="12">
        <info-report-group
          :maneuver="maneuver"
          :fields="getDiagnosticsFields(maneuver)"
          :isDefaultChart="isDefaultChart"
          :isDiagnostics="true"
          class="mb-3"
        />
      </b-col>
    </b-row>
    <b-row
      v-if="!filteredManeuvers.length"
    >
      <b-col cols="12">
        <s-empty-list />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { cleanIncludes, clearDiacritics } from '@/services/stringHelper';
import InfoReportGroup from './InfoReportGroup';

export default {
  components: {
    InfoReportGroup,
  },
  props: {
    reportData: {
      type: Object,
      required: true,
    },
    isDefaultChart: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    tempSearch: null,
    search: null,
  }),
  methods: {
    searchChange(search) {
      this.search = search;
    },
    filterManeuver({ name }) {
      return cleanIncludes(name, this.effectiveQuery, {
        clearValueToFind: false,
      });
    },
    filterManeuverFields(maneuverFields) {
      return maneuverFields.filter(({ name, value }) => cleanIncludes(value, this.effectiveQuery, {
        clearValueToFind: false,
      }) || cleanIncludes(name, this.effectiveQuery, {
        clearValueToFind: false,
      }));
    },
    getDiagnosticsFields(maneuver) {
      if (maneuver.infoData && maneuver.infoData.diagnostics) {
        return maneuver.infoData.diagnostics;
      }

      return [];
    },
    getManeuverKey(maneuver) {
      return maneuver.maneuverKey || maneuver.maneuverUUID || maneuver.name;
    },
  },
  computed: {
    maneuvers() {
      return this.reportData.maneuvers || [];
    },
    filteredManeuvers() {
      const maneuversWithDiagnostics = this.maneuvers.filter(maneuver => {
        const diagnosticsFields = this.getDiagnosticsFields(maneuver);
        return diagnosticsFields.some(field => field.hasValue);
      });

      if (!this.effectiveQuery) {
        return maneuversWithDiagnostics;
      }

      return maneuversWithDiagnostics.reduce((localFilteredManeuvers, maneuver) => {
        if (this.filterManeuver(maneuver)) {
          localFilteredManeuvers.push(maneuver);
          return localFilteredManeuvers;
        }

        const diagnosticsFields = this.getDiagnosticsFields(maneuver);
        const filteredManeuverFields = this.filterManeuverFields(diagnosticsFields);
        if (filteredManeuverFields.length) {
          localFilteredManeuvers.push({
            ...maneuver,
            infoData: {
              ...maneuver.infoData,
              diagnostics: filteredManeuverFields,
            },
          });
        }

        return localFilteredManeuvers;
      }, []);
    },
    effectiveQuery() {
      return this.search && this.search.length >= 2
        ? clearDiacritics(this.search).toLowerCase()
        : null;
    },
  },
};
</script>
